import { Middleware } from "@reduxjs/toolkit";
import { RootState } from "../index";

const loggingMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action: any) => {
    // Type guard to safely access action properties
    if (action && typeof action === "object" && "type" in action) {
      console.log(
        "[Middleware] Dispatching action:",
        action.type,
        "payload" in action ? action.payload : undefined,
      );
    }
    const result = next(action);
    if (action && typeof action === "object" && "type" in action) {
      console.log("[Middleware] Action dispatched:", action.type);
    }
    return result;
  };

export default loggingMiddleware;
